import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid } from '@material-ui/core';
import { formatDateToDDMMYYYYHHSSFrEpoch } from '../../utils/util';
import CustomTypo from '../../components/CustomTypo';
import t from '../../utils/translateUtil';
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress';
import DividerCustom from '../../components/Divider'
import InfiniteScroll from 'react-infinite-scroll-component';
import ButtonCustom from '../../components/ButtonCustom';
import classNames from 'classnames';
import { custom_assets, domainName } from '../../../portal.config';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import { portalCfg } from '../../../portal.router.config';

const drawerWidth = 520;
var path = custom_assets[domainName] && custom_assets[domainName].customImage && custom_assets[domainName].customImage.logo ? portalCfg.publicPath + "/custom_assets" : portalCfg.publicPath + "/assets";


const styles = theme => ({
    container: {
        // borderWidth:1,
        borderRadius: 10,
        backgroundColor: theme.palette.background.box,
        padding: theme.spacing(2),
        marginBottom: theme.spacing(16),
        // height: 230,
    },
    item: {
        // width: 200,
        // height: 200,
        marginLeft: '5%',
        marginRight: '5%',
        border: '1px solid',
        borderColor: theme.palette.border.primary,
        // justifyContent: 'center',
        alignItems: 'center',
        borderRadius: theme.spacing(3),
        cursor: 'pointer',
        background: theme.palette.background.secondary,
        marginBottom: theme.spacing(3),
    },
    item_image: {
        // height: 100,
        padding: theme.spacing(3, 0),
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        textAlign: 'center',
        // marginTop: 8,
    },
    item_name: {
        padding: theme.spacing(1.5, 0)
    },
});

function ProductsView(props) {
    const { classes, t, listProducts, showLoading, handleLoadMore, hasMore, showLoadMore, onClickDetail } = props;
    return (
        <DrawerCustom
            open={props.open}
            onClose={props.onClose}
            title={t('products_tier')}
            large={true}
            children={
                <Grid item>
                    <Grid item container justify='center' alignItems='center'>
                        {showLoading && <CustomizedCircularProgress />}
                    </Grid>
                    {listProducts && <Grid xs={12} item>
                        <InfiniteScroll
                            dataLength={listProducts.length} //This is important field to render the next data
                            next={handleLoadMore}
                            hasMore={hasMore}
                            loader={showLoadMore ? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                            height={window.innerHeight}
                        >
                            <Grid xs={12} item container className={classes.item_list}>
                                {listProducts.map((item, index) => (
                                    <Grid item xs={12} sm={6} key={index}>
                                        <ProductItem
                                            classes={classes}
                                            key={index}
                                            product={item}
                                            currency={props.currency}
                                            onClickDetail={onClickDetail}
                                        />
                                    </Grid>
                                )
                                )}
                            </Grid>
                        </InfiniteScroll>
                    </Grid>}
                </Grid>
            } />
    );
}

function ProductItem(props) {
    var { classes, product } = props;
    let prices = [];
    if(product.prices && product.prices.length > 0){
        prices = product.prices.filter(x => x.price > 0);
        console.log("prices ===", prices);
    }
    var price = prices && prices.length > 0 ? prices[0] : null;
    var price_terms = price && price.price_terms ? price.price_terms : null;
    console.log("price_terms===", price_terms);
    return (
        <Grid item xs={12} onClick={() => props.onClickDetail(product)} className={classes.item}>
            <Grid item className={classes.item_image}>
                {/* <ProductImage classes={classes} image={dataUtil.getImageByUsageTypePortal(product.creatives, usage_type.product_item)} /> */}
                <img src={path + '/images/logo.png'} alt={product.name} style={{height: 100, borderTopLeftRadius: 4, borderTopRightRadius: 4, objectFit: 'contain' }}></img>
            </Grid>
            <Grid item className={classes.item_name}>
                <CustomTypo variant='subtitle2' center>{product.name}</CustomTypo>
            </Grid>
            {price_terms && price_terms.billing_period && <Grid item className={classes.item_name}>
                <CustomTypo variant='subtitle1' center>{t('billing_period')}: {price_terms.billing_period.duration}{price_terms.billing_period.uot}</CustomTypo>
            </Grid>}
            {price_terms && price_terms.contract_period && <Grid item className={classes.item_name}>
                <CustomTypo variant='subtitle1' center>{t('contract_period')}: {price_terms.contract_period.duration}{price_terms.contract_period.uot}</CustomTypo>
            </Grid>}
            <Grid item className={classes.item_footer}>
                <CustomTypo center mg_top_xs variant='h6'>{props.currency}{price && price.price ? price.price : null}</CustomTypo>
            </Grid>
        </Grid>
    )
}

function ProductImage(props) {
    var { classes, image } = props
    if (image && image.url) {
        return <img src={image.url} style={{ height: 100, width: '100%', borderTopLeftRadius: 4, borderTopRightRadius: 4, objectFit: 'contain' }} />
    } else {
        return <Grid item className={classes.item_image} />
    }
}

export default withStyles(styles)(withTranslation()(ProductsView));